import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getStudyAnalyses, 
  getStudyAnalysis,
  createStudyAnalysis,
  clearLocalStudyAnalyses,
  clearLocalActiveStudyAnalysis
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  studyAnalysis: { 
    id: '', 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false,  
    studyAnalysis: false
  }
};

const slice = createSlice({
  name: 'studyAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getStudyAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getStudyAnalyses.fulfilled, (state, action) => {
        const { study_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...study_analyses], 'id');

        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getStudyAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getStudyAnalysis.pending, (state) => {
        state.loading.studyAnalysis = true;
      })
      .addCase(getStudyAnalysis.fulfilled, (state, action) => {
        const { data: { study_analysis }, cable } = action.payload;
        const foundedStudyAnalysis = !!_find(state.all.data, (s) => s.id === study_analysis.id);
        const updatedStudyAnalysis = { ...state.studyAnalysis, ...study_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedStudyAnalysis ? _map(state.all.data, (e) => e.id === study_analysis.id ? { ...e, ...study_analysis } : e) : [...[study_analysis], ...oldAllData]; 
        const pagination = foundedStudyAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.studyAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedStudyAnalysis && !cable) state.studyAnalysis = updatedStudyAnalysis;       
      })
      .addCase(getStudyAnalysis.rejected, (state) => {
        state.loading.studyAnalysis = false;
      })
      .addCase(createStudyAnalysis.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(createStudyAnalysis.fulfilled, (state, action) => {
        const { study_analysis } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[study_analysis], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.all = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.studyAnalysis = study_analysis;  
      })
      .addCase(createStudyAnalysis.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(clearLocalStudyAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveStudyAnalysis, state => {
        state.studyAnalysis = initialState.studyAnalysis;
      })
  }
})

export default slice.reducer;